import {hashFileVersioned} from './hash';
import type {Take} from './model';
export async function matchTakeFile(file: File,takes:Take[]) {
 const hash=await hashFileVersioned(file);
 return {hash,matches:takes.filter(t=>t.hash===hash),bytes:file.size};
}
